/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_TitleInputs */

const cs_field_title = /** @type {(inputs: Field_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Název`)
};

const en_field_title = /** @type {(inputs: Field_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title`)
};

/**
* | output |
* | --- |
* | "Title" |
*
* @param {Field_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const field_title = /** @type {((inputs?: Field_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_title(inputs)
	return cs_field_title(inputs)
});